import { Menu, Transition } from "@headlessui/react";
import Link from "next/link";
import React, { Fragment } from "react";
import Button from "../../Buttons/Button/Button";
import Icon, { Icons } from "../../Icon/Icon";

type LinkProps = React.ComponentProps<typeof Link>;

export interface TableAction {
    label: string;
    title: string;
    onClick?: () => void;
    href?: LinkProps["href"];
    icon?: Icons;
    target?: LinkProps["target"];
}
interface Props {
    buttonLabel?: string;
    items: TableAction[];
    menuWidth?: `${number}rem`;
}

const TableActions = ({ buttonLabel = "actions", items, menuWidth = "10rem" }: Props) => {
    const onChange = (e: React.MouseEvent<HTMLElement>) => {
        let containerElement = e.nativeEvent.target as HTMLElement;
        let parentElement = e.nativeEvent.target as HTMLElement;

        while (containerElement.getAttribute("data-table-container") !== "js-table-container") {
            containerElement = containerElement.parentElement!;
        }

        while (parentElement.getAttribute("data-table-wrapper") !== "js-table-wrapper") {
            parentElement = parentElement.parentElement!;
        }

        if (parentElement.scrollHeight > parentElement.clientHeight) {
            containerElement.style.height = `${parentElement.scrollHeight + 40}px`;
        } else {
            parentElement.style.height = "max-content";
        }

        containerElement.onclick = () => {
            containerElement.style.height = `max-content`;
        };
    };
    return (
        <Menu as="div" className="inline-flex justify-end relative">
            <Menu.Button
                as="div"
                onClick={(e) => {
                    setTimeout(() => {
                        onChange(e);
                    }, 200);
                }}
            >
                <Button variant="borderedMint" className="!hidden md:!inline-flex" icon="chevron_down">
                    {buttonLabel}
                </Button>
                <Button variant="borderedMint" className="!inline-flex md:!hidden " icon="dots_vertical" />
            </Menu.Button>
            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items
                    as="ul"
                    // eslint-disable-next-line max-len
                    className="absolute origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10 translate-y-3"
                    style={{ width: menuWidth }}
                >
                    {items.map((item) => {
                        let render;

                        if (item.href) {
                            render = (
                                <Link
                                    className="w-full flex p-1 justify-between gap-1 type-small-caps"
                                    title={item.title}
                                    href={item.href}
                                    target={item.target}
                                >
                                    {item.label}
                                    {item.icon && <Icon icon={item.icon} />}
                                </Link>
                            );
                        } else {
                            render = (
                                <button
                                    type="button"
                                    className="w-full flex p-1 justify-between gap-1 type-small-caps"
                                    title={item.title}
                                    onClick={item.onClick}
                                >
                                    {item.label}
                                    {item.icon && <Icon icon={item.icon} />}
                                </button>
                            );
                        }

                        return (
                            <Menu.Item as="li" key={item.label}>
                                {render}
                            </Menu.Item>
                        );
                    })}
                </Menu.Items>
            </Transition>
        </Menu>
    );
};

export default TableActions;
